import { createFileRoute } from '@tanstack/react-router'

import { RoomEditView } from '@/modules/rooms'

export const Route = createFileRoute('/_auth/rooms/$roomId/edit')({
  component: RoomEditView
})
